export const ApiErrorCode = {
    API_ERROR: '@API/ERROR',
    AUTHENT_UNAUTHENTICATED: '@AUTHENT/UNAUTHENTICATED',
    AUTHENT_UNAUTHORIZED: '@AUTHENT/UNAUTHORIZED',
    AUTHENT_PLUGIN_UNAUTHORIZED: 'UNAUTHORIZED',
    AUTHENT_UNAUTHORIZED_ROLE: '@AUTHENT/UNAUTHORIZED_ROLE',
    AUTHENT_UNAUTHORIZED_PERMISSION: '@AUTHENT/UNAUTHORIZED_PERMISSION',
    AUTHENT_ACCOUNT_DEACTIVATED: '@AUTHENT/ACCOUNT_DEACTIVATED',
    UNAUTHORIZED_DATA_ACCESS_PERMISSIONS: '@UNAUTHORIZED/DATA_ACCESS_PERMISSIONS',
    UNAUTHORIZED_DIMENSIONS: '@UNAUTHORIZED/DIMENSIONS',
    DATA_NOT_FOUND: '@DATA/NOTFOUND',
    DATA_WRONG_REQUEST: '@DATA/WRONG_REQUEST',
    DATA_NOT_AVAILABLE_FOR_THIS_REFERENTIAL: '@DATA/NOT_AVAILABLE_FOR_THIS_REFERENTIAL',
    DATA_DUPLICATE: '@DATA/DUPLICATE',
    USER_EXPIRED_TOKEN: '@USER/EXPIRED_TOKEN',
    USER_ALREADY_HAS_AN_ACCESS_REQUEST: '@USER/ALREADY_HAS_AN_ACCESS_REQUEST',
    HOLDING_MISSING_ACCOUNT_MANAGER: '@HOLDING/MISSING_ACCOUNT_MANAGER',
    HOLDING_DELETE_OWN_USER: '@HOLDING/DELETE_OWN_USER',
    HOLDING_DELETE_ACCOUNT_MANAGER_USER: '@HOLDING/DELETE_ACCOUNT_MANAGER_USER',
    EXPORT_TIMEOUT: '@EXPORT/TIMEOUT',
    GATEWAY_TIMEOUT: '@GATEWAY/TIMEOUT'
};
export const ApiRestErrorCode = {
    EXTERNAL_API_ERROR: '@EXTERNAL_API/ERROR'
};
export function isApiErrorCode(errorCode) {
    return Object.values(ApiErrorCode).includes(errorCode);
}
//# sourceMappingURL=error.model.js.map